// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#table {
  width: 94%;
  border-collapse: collapse;
  margin-top: 10px;
  margin-left: 35px;
}

.table-container {
  margin-top: 20px;
  margin-left: 35px;
}

#table td, #table th {
  padding: 8px;
  text-align: center;
  border: 1px solid #ddd;
}

#table th {
  background-color: #28a745;
  color: #ffffff;
}

#table tr:nth-child(even) {
  background-color: #f2f2f2;
}

#table tr:hover {
  background-color: #ddd;
}

.highlight-red {
  background-color: red !important;
  color: white !important;
} 
  

.loading-indicator {
  position: absolute;
  top: 50%; 
  left: 50%; 
  transform: translate(-50%, -50%); 
  z-index: 9999; 
}

.loading-indicator img {
  animation: spin 1s linear infinite;
  width: 100px; 
  height: 100px; 
  border-radius: 50px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.header-left {
  text-align: left;
  margin-left: 20px;
}

/* Performance button */
#alertButton {
  background-color: #f3bc07; 
  /* color: #333; Dark text color for contrast */
  border: 1px solid #ccc; 
  border-radius: 4px; 
  padding: 10px 20px;
  font-size: 16px; 
  cursor: pointer; 
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
 
}

#alertButton:hover {
  background-color: #f5f507; 
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); 
}

#alertButton:focus {
  outline: none; 
  box-shadow: 0 0 0 3px rgba(255, 255, 0, 0.5); 
}

.report-table {
  display: flex;
  align-items: center; 
  margin-left:300px;
  gap: 20px; 
}
/* download button styles */
.download-container {
  position: absolute; 
  right: 90px;
  background-color:#e7dddd;
}

.download-options {
  position: absolute; 
  top: 100%; 
  left: 0;
  background-color: #fff;
  border: 1px solid #ddd; 
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); 
  padding: 10px; 
  z-index: 1000; 
  display: flex;
  flex-direction: column; 
}

.download-options div {
  margin-bottom: 5px;
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;
}

.download-options div:hover {
  background-color: #f0f0f0; 
}


.total-power {
  padding: 12px;
  width:250px;
  height:65px;
  background-color:white; 
  border-radius: 8px; 
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);  */
  margin-top: -2px;
  margin-left:900px;
  border: none;
  font-weight:bold;
}
`, "",{"version":3,"sources":["webpack://./src/components/Reports/DataTable.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,4DAA4D;;AAE9D;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;AACX;AACA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,sBAAsB;EACtB,sBAAsB;EACtB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,+CAA+C;EAC/C,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":["#table {\r\n  width: 94%;\r\n  border-collapse: collapse;\r\n  margin-top: 10px;\r\n  margin-left: 35px;\r\n}\r\n\r\n.table-container {\r\n  margin-top: 20px;\r\n  margin-left: 35px;\r\n}\r\n\r\n#table td, #table th {\r\n  padding: 8px;\r\n  text-align: center;\r\n  border: 1px solid #ddd;\r\n}\r\n\r\n#table th {\r\n  background-color: #28a745;\r\n  color: #ffffff;\r\n}\r\n\r\n#table tr:nth-child(even) {\r\n  background-color: #f2f2f2;\r\n}\r\n\r\n#table tr:hover {\r\n  background-color: #ddd;\r\n}\r\n\r\n.highlight-red {\r\n  background-color: red !important;\r\n  color: white !important;\r\n} \r\n  \r\n\r\n.loading-indicator {\r\n  position: absolute;\r\n  top: 50%; \r\n  left: 50%; \r\n  transform: translate(-50%, -50%); \r\n  z-index: 9999; \r\n}\r\n\r\n.loading-indicator img {\r\n  animation: spin 1s linear infinite;\r\n  width: 100px; \r\n  height: 100px; \r\n  border-radius: 50px;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n.header-left {\r\n  text-align: left;\r\n  margin-left: 20px;\r\n}\r\n\r\n/* Performance button */\r\n#alertButton {\r\n  background-color: #f3bc07; \r\n  /* color: #333; Dark text color for contrast */\r\n  border: 1px solid #ccc; \r\n  border-radius: 4px; \r\n  padding: 10px 20px;\r\n  font-size: 16px; \r\n  cursor: pointer; \r\n  transition: background-color 0.3s ease, box-shadow 0.3s ease;\r\n \r\n}\r\n\r\n#alertButton:hover {\r\n  background-color: #f5f507; \r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); \r\n}\r\n\r\n#alertButton:focus {\r\n  outline: none; \r\n  box-shadow: 0 0 0 3px rgba(255, 255, 0, 0.5); \r\n}\r\n\r\n.report-table {\r\n  display: flex;\r\n  align-items: center; \r\n  margin-left:300px;\r\n  gap: 20px; \r\n}\r\n/* download button styles */\r\n.download-container {\r\n  position: absolute; \r\n  right: 90px;\r\n  background-color:#e7dddd;\r\n}\r\n\r\n.download-options {\r\n  position: absolute; \r\n  top: 100%; \r\n  left: 0;\r\n  background-color: #fff;\r\n  border: 1px solid #ddd; \r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); \r\n  padding: 10px; \r\n  z-index: 1000; \r\n  display: flex;\r\n  flex-direction: column; \r\n}\r\n\r\n.download-options div {\r\n  margin-bottom: 5px;\r\n  padding: 8px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.download-options div:hover {\r\n  background-color: #f0f0f0; \r\n}\r\n\r\n\r\n.total-power {\r\n  padding: 12px;\r\n  width:250px;\r\n  height:65px;\r\n  background-color:white; \r\n  border-radius: 8px; \r\n  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);  */\r\n  margin-top: -2px;\r\n  margin-left:900px;\r\n  border: none;\r\n  font-weight:bold;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
